import { createApp, defineAsyncComponent } from 'vue';
import { imgLoader, videoLoader, scrollHandler, expandableHandler } from './utils/helpers.js';
import { fixOrphans } from './utils/typography.js';
import { registerSwiper } from './utils/swiper.js';

expandableHandler();

if (typeof document !== 'undefined' && document.querySelector('swiper-container, swiper-slide')) {
    registerSwiper();
}

import ContactLink from '../vue/components/ContactLink.vue';
import ContactInfo from '../vue/components/ContactInfo.vue';
import ContactFlag from '../vue/components/ContactFlag.vue';

const RandomSwiper = defineAsyncComponent(() => import('../vue/components/RandomSwiper.vue'));
const ExpandableContent = defineAsyncComponent(() => import('../vue/components/ExpandableContent.vue'));

// Initial global call
document.addEventListener('DOMContentLoaded', () => {
    imgLoader();
    videoLoader();
    fixOrphans();
    scrollHandler();
});

// Dynamically import modules
const modules = {
    Product: () => import('../vue/modules/Product.vue'),
    Menu: () => import('../vue/modules/Menu.vue'),
    Privacy: () => import('../vue/modules/Privacy.vue'),
    Category: () => import('../vue/modules/Category.vue'),
    Page: () => import('../vue/modules/Page.vue'),
    PageWithFaq: () => import('../vue/modules/PageWithFaq.vue'),
    Customization: () => import('../vue/modules/Customization.vue'),
    Pdf: () => import('../vue/modules/Pdf.vue'),
};

const moduleElements = document.querySelectorAll('[data-module]');

moduleElements.forEach((element) => {
    const moduleName = element.getAttribute('data-module');
    const moduleProps = JSON.parse(element.getAttribute('data-props') || '{}');

    // Dynamically load and mount the Vue component
    if (moduleName && modules[moduleName]) {
        modules[moduleName]().then((module) => {
            const app = createApp(module.default, moduleProps);

            app.mixin({
                mounted() {
                    imgLoader();
                    videoLoader();
                    fixOrphans();
                    scrollHandler();
                },
                updated() {
                    imgLoader();
                    videoLoader();
                    fixOrphans();
                    scrollHandler();
                }
            });
            app.component('ContactInfo', ContactInfo);
            app.component('ContactLink', ContactLink);
            app.component('contactflag', ContactFlag);
            app.component('RandomSwiper', RandomSwiper);
            app.component('ExpandableContent', ExpandableContent);
            app.mount(element);
        });
    } else {
        console.error(`No Vue component found for module: ${moduleName}`);
    }
});
